export enum PhaseContract {
    ToConfirmByAgency = 0,
    ToConfirmByPatavium = 1,
    Exportable = 2,
    StopForErrors = 3,
    CancelForChangingOfMind = 4,
    CancelForExceedingTime = 5,
    Rejected = 6,
    Draft = 7,
    //inizio fasi che agenzia deve vedere come in progress
    ExportFail = 8,
    ExportSuccess = 9,
    ExportPartial = 10,
    ExportInProgess = 11,
    ParcelValidation = 12,
    ConclusionPartial = 13,
    StoppedByAgency = 14,
    InAttesaDiAdesione = 15,
    AdesioneConfermata = 16,
    AnnullatoDalCliente = 17,
    AnnullatoCausaAgenzia = 18,
    AnnullatoCausaCte = 19,
    RespintoTeleselling = 20,
    AttesaChiamataVerifica = 21,
    RifiutatoDopoChiamataVerifica = 22,
    AnnullatoCausaVincoliTemporali = 23,
    RespintoCausaChiamataPreAdesione = 24,
    RespintoCausaChiamataAdesione = 25,
    AnnullatoCausaClienteIrreperibile = 26,
    AnnullatoCausaNumeroTelefonicoErrato = 27,
    CheckChiamataDiVerifica = 28,
    RipensamentoCausaAgenzia = 29,
    RifiutoRegistrazioneChiamata = 30,
    RifiutatoCausaChiamataVerifica = 31,
    VadAttesaRispostaCliente = 32,
    VadPreValidazioneBackoffice = 33,
    VadAttesaGestione = 34,
    RespintoCausaAllegatoChiamataPreAdesione = 35,
    CambioPiano = 36,
    AttesaEsitoDistributore = 37,
    InAttesaDiAdesionePec = 38,
    RinnovoPerScadenza = 39,
    Rebranding = 40,
    ReCallDisdettato = 41,
    AttesaSaldo = 42,
    PropostaAnnullata = 43,
    RifiutoProposta = 44,
    AttesaRestituzionePlico = 45,
    CheckVocalOrder = 46,
    PropostaScaduta = 47,
    VocalOrderNonConforme = 48,
    RebrandingAjoSrl = 49,
    InAttesaDiVerificaPec = 50,
    RichiestaDisdetta = 51,
    RichiestaCessazione = 52,
    InAttesaFirmaDigitale = 53,
    SwitchingVerification = 1000, //Verifica Switching
    CancelForChangingOfMindEnerp = 1001, //Ripensamento enerp
    PreCheckOk = 1002, //PreCheck OK
    PreCheckKo = 1003, //PreCheck KO
    SwitchingRequest = 1004, //Switching richiesto
    CancelForCMOR = 1005, //Annullamento per CMOR
    SwitchingRejected = 1006, //Switching respinto
    SwitchingAcquired = 1007, //Switching Acquisito
    //fine fasi che agenzia deve vedere come in progress
    Validate = 1008, //Validato
    Conclusion = 1009, //Concluso
    LoadingExport = 2000,
    AttesaChiamataBenvenuto = 2001,
    ChiamataBenvenutoEseguita = 2002,
    AttesaRicevimentoPlicoFirmato = 2003,
    AttesaVocalOrder = 2004,
    PreScreeningKO = 2005,
    RespintoTuristaEnergetico = 2006,
    AnnullatoDatiIncongruenti = 2007,
    AnnullatoSwitchMultipli = 2008,
    RipensamentoTelefonico = 2009,
    RipensamentoScritto = 2010,
    RipensamentoCondizioniEconomiche = 2011,
    RipensamentoContatoreChiuso = 2012,
    RipensamentoFrequenzaFatturazione = 2013,
    RipensamentoContrattoSottoscrittoInconsapevolmente = 2014,
    RipensamentoTerminiPagamento = 2015,
    AnnullatoMancanzaDelega = 2016,
    AnnullatoIntestatarioDiverso = 2017,
    ChiamataBenvenutoNonRisponde = 2018,
    PreVerificheBackoffice = 2019,
    AnnullatoProvenienzaDefault = 2020,
    DidettatoVolutaAttivazione = 2021

}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/enums/phaseContract.enum.ts